import {
	CaseReducer,
	createAsyncThunk,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SessionData, TempUserData } from '@/components/templates/search/interfaces/ISessionData';
import { SessionContext } from '../globalContext/sessionContext.interface';


type State = SessionContext;

export const initialState: State = {
	isLogin: null,
	isGuest: null,
	userData: {
		name: '',
		email: ''
	}
}

const setSessionDataReducer: CaseReducer<State, PayloadAction<SessionData>> = (state, action) => {
	const { logeado, invitado, user } = action.payload ?? {};
	state.isLogin = logeado;
	state.isGuest = invitado;
	state.userData.name = user.name;
	state.userData.email = user.email;
}

const setLogOutReducer: CaseReducer<State> = (state) => {
	state.isLogin = false;
	state.isGuest = true;
}

const setTempLoginDataReducer: CaseReducer<State, PayloadAction<TempUserData>> = (state, action) => {
	const { name, email } = action.payload ?? {};
	state.userData.name = name;
	state.userData.email = email;
	state.isGuest = true;
}

export const SessionSlice = createSlice({
	name: 'session',
	initialState,
	reducers: {
		setSessionData: setSessionDataReducer,
		setLogOut: setLogOutReducer,
		setTempLogInData: setTempLoginDataReducer
	}
})

export const selectSessionState = (state: RootState) => state.SessionState;
export const { setSessionData, setLogOut, setTempLogInData } = SessionSlice.actions;